import { WHATSAPP_NUMBER, WHATSAPP_MESSAGE } from "@/config";

export const WhatsAppButton = () => {
    const href = `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, "")}?text=${encodeURIComponent(
        WHATSAPP_MESSAGE
    )}`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-fab"
            aria-label="Chat with us on WhatsApp"
            className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-[80] group"
        >
            <span className="relative flex h-14 w-14 sm:h-16 sm:w-16">
                <span className="absolute inset-0 rounded-full bg-brand-primary/30 animate-ping opacity-40" />
                <span className="relative flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-full bg-brand-primary text-brand-bg shadow-[0_8px_30px_rgba(140,190,210,0.25)] transition-all duration-300 group-hover:scale-105 group-hover:bg-brand-sky">
                    <svg
                        viewBox="0 0 32 32"
                        className="w-7 h-7 sm:w-8 sm:h-8"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path d="M19.11 17.49c-.29-.15-1.73-.85-2-.95s-.46-.15-.66.15-.76.95-.93 1.15-.34.22-.63.07a8.1 8.1 0 0 1-2.39-1.47 9 9 0 0 1-1.65-2.06c-.17-.29 0-.45.13-.6s.29-.34.44-.51a2 2 0 0 0 .29-.49.54.54 0 0 0 0-.51c-.07-.15-.66-1.59-.91-2.18s-.49-.49-.66-.5h-.56a1.07 1.07 0 0 0-.78.36 3.25 3.25 0 0 0-1 2.41 5.65 5.65 0 0 0 1.18 3 13 13 0 0 0 4.92 4.34c.69.3 1.23.48 1.65.61a4 4 0 0 0 1.82.11 3 3 0 0 0 2-1.39 2.43 2.43 0 0 0 .17-1.39c-.07-.13-.26-.21-.55-.36zM16 4a12 12 0 0 0-10.27 18.16L4 28l5.93-1.71A12 12 0 1 0 16 4zm0 21.82a9.83 9.83 0 0 1-5-1.37l-.36-.21-3.7 1.07 1.1-3.6-.24-.37A9.83 9.83 0 1 1 16 25.82z" />
                    </svg>
                </span>
            </span>
        </a>
    );
};
